import { createFileRoute } from "@tanstack/react-router";
import Crm from "@/pages/crm/Crm";

export const Route = createFileRoute("/crm/")({
  head: () => ({
    meta: [
      { title: "CRM Contactos | SEOEVOLUTION" },
      { name: "description", content: "Panel privado de gestión de contactos de SEOEVOLUTION." },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { property: "og:url", content: "https://agenciaseoevolution.com/crm" },
      { property: "og:title", content: "CRM Contactos | SEOEVOLUTION" },
      { property: "og:description", content: "Panel privado de gestión de contactos de SEOEVOLUTION." },
      { name: "twitter:title", content: "CRM Contactos | SEOEVOLUTION" },
      { name: "twitter:description", content: "Panel privado de gestión de contactos de SEOEVOLUTION." },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/crm" }],
  }),
  component: Crm,
});
